module.exports = __webpack_public_path__ + "img/FR16688.51d4e2d8.png";